import React from "react";

function FordIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2100"
      height="937"
      viewBox="6.077 6.461 289.506 108.556"
    >
      <path
        fill="#C9C9CA"
        d="M150.824 6.461C70.48 6.461 6.077 30.543 6.077 60.736c0 30.015 64.935 54.281 144.748 54.281 79.818 0 144.758-24.35 144.758-54.281-.002-29.925-64.94-54.275-144.759-54.275m143.873 50.084c.052.265.088.533.134.79-.038-.256-.091-.522-.134-.79"
      />
      <radialGradient
        id="aGradFord"
        cx="-4308.92"
        cy="1124.903"
        r="623.715"
        gradientTransform="matrix(1 0 0 .5079 4458.79 -385.786)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".155" stopColor="#000a30" />
        <stop offset=".242" stopColor="#010f39" />
        <stop offset=".312" stopColor="#011946" />
        <stop offset=".373" stopColor="#02275a" />
        <stop offset=".414" stopColor="#03346c" />
        <stop offset=".439" stopColor="#0b4f87" />
        <stop offset=".48" stopColor="#1676af" />
        <stop offset=".513" stopColor="#1c8ec7" />
        <stop offset=".533" stopColor="#1f97d0" />
        <stop offset="1" stopColor="#1f97d0" />
      </radialGradient>
      <path
        fill="url(#aGradFord)"
        d="M150.829 8.628c-78.746 0-142.534 23.276-142.534 52.08 0 28.79 63.788 52.081 142.534 52.081 78.756 0 142.528-23.291 142.528-52.081 0-28.802-63.773-52.08-142.528-52.08"
      />
      <linearGradient
        id="bGradFord"
        x1="-5277.681"
        x2="-5274.415"
        y1="387.685"
        y2="387.685"
        gradientTransform="matrix(0 -33.7605 -33.7605 0 13239.004 -178060.938)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#bGradFord)"
        d="M151.477 19.549c66.949 0 122.229 16.356 130.674 37.526v-.004C276.51 34.8 219.872 17.304 150.818 17.304c-72.788 0-131.789 19.435-131.789 43.42 0 1.955.395 3.875 1.149 5.762a14.772 14.772 0 0 1-.495-3.771c.002-23.837 59.005-43.166 131.794-43.166z"
      />
      <linearGradient
        id="cGradFord"
        x1="-5277.683"
        x2="-5274.414"
        y1="387.647"
        y2="387.647"
        gradientTransform="rotate(-90 -82410.73 -95650.249) scale(33.7605)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#cGradFord)"
        d="M286.525 55.292a17.43 17.43 0 0 1 .873 5.433c0 26.258-61.147 47.541-136.582 47.541-67.131 0-122.943-16.861-134.426-39.062 8.713 23.075 65.786 40.901 134.971 40.977h.836c75.238-.074 136.166-21.142 136.166-47.138.002-2.637-.627-5.233-1.838-7.751z"
      />
      <linearGradient
        id="dGradFord"
        x1="-5286.4"
        x2="-5283.136"
        y1="383.751"
        y2="383.751"
        gradientTransform="matrix(0 -23.7353 -23.7353 0 9283.99 -125376.773)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#dGradFord)"
        d="M177.1 68.042c-.301-.764-.357-1.622-.184-2.475.061-.303-.33-.575-.65-.246-3.059 3.189-3.287 7.314-1.283 9.166.715.666 1.539.965 2.416 1.021-1.305-1.656-1.922-4.903-.299-7.466z"
      />
      <linearGradient
        id="eGradFord"
        x1="-5286.465"
        x2="-5283.215"
        y1="382.766"
        y2="382.766"
        gradientTransform="matrix(0 -23.6812 -23.6812 0 9272.605 -125092.438)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#eGradFord)"
        d="M208.088 74.182h.004c.156-.302.312-.621.479-.963.127-.263.064-.337-.045-.381-.314-.113-.639-.354-.684-.603-.021-.045-.023-.088-.027-.139l.004.027c.04.481.167 1.387.269 2.059z"
      />
      <linearGradient
        id="fGradFord"
        x1="-5286.456"
        x2="-5283.222"
        y1="382.627"
        y2="382.627"
        gradientTransform="matrix(0 -23.681 -23.681 0 9273.978 -125091.39)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#fGradFord)"
        d="M211.562 61.693c1.021.979 1.644 2.166 1.76 3.258.045.517.439.574.761.123.084-.123.18-.276.293-.448-.088-.125-.185-.245-.275-.363a28.27 28.27 0 0 0-2.539-2.57z"
      />
      <linearGradient
        id="gGradFord"
        x1="-5286.457"
        x2="-5283.18"
        y1="383.887"
        y2="383.887"
        gradientTransform="matrix(0 -23.6962 -23.6962 0 9266.934 -125171.258)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#gGradFord)"
        d="M169.193 59.684c.82 1.121 1.203 2.722 1.146 4.771-.014.531.373.496.625.134.144-.201.271-.379.404-.562v-.016c-.598-1.837-1.516-3.641-2.175-4.327z"
      />
      <linearGradient
        id="hGradFord"
        x1="-5286.429"
        x2="-5283.167"
        y1="382.995"
        y2="382.995"
        gradientTransform="matrix(0 -23.7124 -23.7124 0 9282.72 -125256.414)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#hGradFord)"
        d="M207.281 65.104c-2.522-1.211-6.37 1.01-9.852 5.295-2.854 3.504-4.392 7.067-4.445 10.541-.022 1.238.447 2.768 1.537 3.326a3.33 3.33 0 0 0 1.09.377 5.543 5.543 0 0 1-.19-1.396c-.043-3.585 1.071-7.165 3.932-10.674 3.457-4.264 7.094-6.389 9.619-5.215-.13-.938-.618-1.747-1.691-2.254z"
      />
      <linearGradient
        id="iGradFord"
        x1="-5286.497"
        x2="-5283.231"
        y1="384.929"
        y2="384.929"
        gradientTransform="matrix(0 -23.6585 -23.6585 0 9240.934 -124973.14)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#iGradFord)"
        d="M131.846 72.206c2.658-3.604 5.652-4.967 9.066-6.442.45-.197.504-.451.418-.849-.146-.68-.62-2.368-.765-2.774.108.371.012.655-.432.82-3.874 1.471-7.758 3.755-10.445 7.354-3.048 4.084-3.865 8.996-1.829 11.826.485.662 1.063 1.153 1.701 1.473-1.097-3.38-.296-7.912 2.286-11.408z"
      />
      <linearGradient
        id="jGradFord"
        x1="-5286.463"
        x2="-5283.195"
        y1="383.964"
        y2="383.964"
        gradientTransform="matrix(0 -23.6866 -23.6866 0 9262.28 -125120.828)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#jGradFord)"
        d="M151.348 93.582c2.619 0 5.838 0 8.016-.013.324-.018.555-.201.725-.443 3.255-5.1 6.73-10.633 10.056-15.737.729 2.575 1.104 3.773 2.461 4.986 1.381 1.233 2.658 1.557 4.537 1.573 1.707.021 3.389-.661 5.391-1.492a12.36 12.36 0 0 0 1.937-1.039c0-.946.096-1.897.264-2.805.014-.098-.082-.727-.619-.354a15.246 15.246 0 0 1-3.621 1.947c-1.844.688-2.703.946-4.41.93-2.147-.017-4.082-.93-5.442-3.054-.761-1.147-1.076-2.896-1.148-4.18-.01-.141-.194-.391-.396-.067-3.609 5.516-6.979 10.846-10.561 16.447-.187.264-.349.436-.72.448-2.213 0-4.637-.006-7.074.008-.255 0-.438-.117-.491-.295.191.855.504 2.404.586 2.766.054.245.237.374.509.374z"
      />
      <linearGradient
        id="kGradFord"
        x1="-5286.21"
        x2="-5282.945"
        y1="382.868"
        y2="382.868"
        gradientTransform="matrix(0 -23.8873 -23.8873 0 9354.098 -126175.594)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#kGradFord)"
        d="M186.389 90.531c.604 1.16 1.959 2.462 2.781 2.871 4.694 2.313 11.396-.309 15.701-4.447.043-.057.053-.061.114-.128.197.743.439 1.646.474 1.771.293.961.754 1.834 1.157 2.297 2.945 3.328 9.197 1.813 15.705-3.223 3.638-2.812 6.334-5.636 9.638-9.479.133-.16.121-.396.047-.756-.189-.836-.486-2.348-.652-3.108a.619.619 0 0 1-.127.35c-3.449 4.205-7.262 8.18-10.908 10.992-5.67 4.393-11.33 5.508-14.127 2.692-1.047-1.047-1.619-2.543-1.688-3.812-.034-.688-.383-.72-.713-.397-3.342 3.311-9.151 6.977-14.446 4.365-2.73-1.348-4.154-3.877-4.666-6.66.004.029.014.064.021.095.327 1.972.756 4.819 1.689 6.577z"
      />
      <linearGradient
        id="lGradFord"
        x1="-5286.288"
        x2="-5283.023"
        y1="383.603"
        y2="383.603"
        gradientTransform="matrix(0 -23.8273 -23.8273 0 9322.35 -125860.21)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#lGradFord)"
        d="M184.053 72.573c1.742-.943 3.272-2.943 3.082-6.188-.101-1.615-.568-3.279-1.324-4.621.514.979.729 2.119.547 3.32-.334 2.094-1.469 3.94-3.398 4.896-1.635.801-3.545.66-4.883-.533a3.87 3.87 0 0 1-.936-1.322c.344 1.582.645 2.745 1.057 3.368 1.261 1.902 3.445 2.382 5.855 1.08z"
      />
      <linearGradient
        id="mGradFord"
        x1="-5286.492"
        x2="-5283.226"
        y1="382.286"
        y2="382.286"
        gradientTransform="matrix(0 -23.6646 -23.6646 0 9270.94 -125005.188)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#mGradFord)"
        d="M235.865 45.17c-1.098 1.901-22.301 34.182-23.641 37.521-.424 1.057-.474 1.865-.043 2.447.438.586 1.076.809 1.801.797.074-.408.229-.867.422-1.352 1.34-3.351 21.197-33.526 22.287-35.436.09-.163.058-.346.029-.468-.064-.303-.73-3.511-.795-3.812a.435.435 0 0 1-.06.303z"
      />
      <linearGradient
        id="nGradFord"
        x1="-5286.46"
        x2="-5283.189"
        y1="384.488"
        y2="384.488"
        gradientTransform="matrix(0 -23.6911 -23.6911 0 9258.602 -125144.477)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#nGradFord)"
        d="M147.864 60.193c.062.067.111.134.165.201 1.276 1.899 1.972 4.572 2.042 7.333.076.582.325.596.607.297.258-.262.51-.541.758-.81-.373-1.483-.951-2.817-1.546-4.104-.222-.464-1.19-2.128-2.026-2.917z"
      />
      <linearGradient
        id="oGradFord"
        x1="-5286.469"
        x2="-5283.205"
        y1="384.837"
        y2="384.837"
        gradientTransform="matrix(0 -23.6823 -23.6823 0 9251.416 -125098.227)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#oGradFord)"
        d="M113.646 90.365c.386.195.785.018.977-.09 1.293-.662 3.811-2.598 4.896-3.949.329-.307.645-.098.75.229.453 1.436 1.117 2.543 1.861 3.721.81 1.312 2.438 2.672 4.547 3.25 2.729.765 5.674.9 9.545-.578 3.104-1.188 6.357-3.608 8.858-6.327 3.002-3.259 4.088-5.347 5.225-6.771 1.947-2.41 4.978-6.679 9.226-10.303 1.486-1.271 3.113-2.095 4.134-1.695.614-1.582.323-2.455-.33-2.875-.994-.647-2.982.324-4.66 1.604-4.574 3.464-8.417 8.86-10.363 11.274-1.148 1.42-2.23 3.515-5.228 6.771-4.713 5.116-10.962 8.057-16.99 6.026-3.29-1.106-5.671-3.752-6.577-7.002-.182-.627-.533-.803-.875-.389-.973 1.217-2.964 3.004-4.627 4.129-.182.131-.632.397-1.018.205-.348-.158-1.583-1.902-1.825-2.404a.487.487 0 0 1-.061-.168v.022c.434 2.146.488 2.396 1.075 3.388.665 1.094 1.313 1.87 1.46 1.932z"
      />
      <linearGradient
        id="pGradFord"
        x1="-5286.495"
        x2="-5283.226"
        y1="386.54"
        y2="386.54"
        gradientTransform="matrix(0 -23.6627 -23.6627 0 9225.805 -124995.203)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#pGradFord)"
        d="M77.297 71.087c1.522-3.069 3.664-4.534 5.77-5.866.906-.574 1.308-1.13.769-2.625-.153-.427-.239-1.195-.409-1.875.054.664-.274 1.235-.861 1.541-2.572 1.312-5.668 3.561-7.196 6.629-1.242 2.5-1.494 5.525.398 8.399.159.229.331.461.521.674h.002c-.608-2.386.046-4.956 1.006-6.877z"
      />
      <linearGradient
        id="qGradFord"
        x1="-5286.219"
        x2="-5282.95"
        y1="385.616"
        y2="385.616"
        gradientTransform="matrix(0 -23.8868 -23.8868 0 9324.986 -126172.875)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#qGradFord)"
        d="M103.631 33.82c9.351-3.084 19.775-1.134 28.148.658 1.171-.731 2.196-1.236 3.223-1.799.511-.268-.061-.587-.22-.587-10.809-2.029-22.042-4.661-32.773-.687-7.438 2.776-10.697 8.673-9.124 12.61.3.751.779 1.335 1.404 1.75-.525-3.631 2.197-9.581 9.342-11.945z"
      />
      <linearGradient
        id="rGradFord"
        x1="-5286.477"
        x2="-5283.209"
        y1="385.825"
        y2="385.825"
        gradientTransform="matrix(0 -23.6757 -23.6757 0 9238.438 -125063.516)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#rGradFord)"
        d="M73.215 90.338c3.065 2.16 6.083 2.876 9.604 2.938 7.152.125 13.685-2.828 20.613-9.858 6.651-6.75 12.408-16.183 18.085-25.531.188-.329.389-.476 1.34-.6 3.562-.439 6.753-.643 9.899-.938.938-.088 1.651-.174 1.995.166 1.136 1.137 2.458 2.176 3.332 2.684.581.007 1.069.135 1.41.44.367-.048.702-.252.919-.463.408-.399.424-.866.357-1.262-.141-.777-.351-2.308-.6-2.752.172.338.061.816-.278 1.199-.249.284-.638.553-1.133.547-.409-.01-.651-.15-1.165-.432-1.061-.567-2.371-1.506-3.252-2.615-.297-.372-.45-.382-1.2-.34-3.364.196-8.613.7-12.172 1.147-.858.107-.986.268-1.165.562-5.671 9.354-11.725 19.437-18.373 26.188-7.129 7.24-13.059 9.141-19.349 9.19-7.259.051-13.718-4.062-15.356-11.289v.004c.885 4.038 3.486 8.896 6.489 11.015z"
      />
      <linearGradient
        id="sGradFord"
        x1="-5286.366"
        x2="-5283.099"
        y1="385.807"
        y2="385.807"
        gradientTransform="matrix(0 -23.7655 -23.7655 0 9274.508 -125535.422)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#sGradFord)"
        d="M100.032 58.915a1.537 1.537 0 0 1-.252-.813c-.074 1.212.415 2.994.807 3.589.431.664 1.644.99 2.604.274 2.17-1.598 4.129-2.529 6.321-2.944.563-.771 1.171-1.625 1.867-2.585.061-.075.077-.175.051-.225-.039-.087-.109-.112-.25-.118-3.213.089-6.021 1.05-8.741 3.083-.783.572-1.913.491-2.407-.261z"
      />
      <linearGradient
        id="tGradFord"
        x1="-5286.496"
        x2="-5283.224"
        y1="384.222"
        y2="384.222"
        gradientTransform="matrix(0 -23.6632 -23.6632 0 9250.164 -124997.836)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#tGradFord)"
        d="M187.492 37.01c-4.495 2.467-9.192 3.212-14.104 3.255-11.875.097-22.938-4.53-34.382-7.016.016.499.146 1.098-.274 1.414-6.338 4.674-12.069 9.425-15.909 16.092-.127.156-.057.3.166.284 1.012-.046 1.991-.092 2.956-.145 3.497-5.478 7.238-8.618 12.95-12.834.428-.324.855-.549.715-1.768 11.48 2.549 20.21 6.771 35.035 6.81 4.424.015 10.662-1.46 14.018-3.479 3.857-2.32 4.883-4.026 5.021-5.829.045-.563-.104-1.399-.195-1.83-.131-.611-.217-1.391-.391-1.971.059.236.086.503.064.796-.117 2.074-1.721 4.067-5.67 6.221z"
      />
      <linearGradient
        id="uGradFord"
        x1="-5286.426"
        x2="-5283.16"
        y1="384.837"
        y2="384.837"
        gradientTransform="matrix(0 -23.7167 -23.7167 0 9265.193 -125278.984)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#uGradFord)"
        d="M137.89 44.749c-.141.134-.3.271-.457.415-1.133 1.173-1.478 2.726-1.312 3.901.093.478.277.571.495.53a4.02 4.02 0 0 0 .657-.206c.08-.647.351-1.275 1.005-1.851.473-.418 1.066-.612 1.573-.528.437-.866.562-1.908.029-2.373-.512-.442-1.329-.359-1.99.112z"
      />
      <linearGradient
        id="vGradFord"
        x1="-5286.49"
        x2="-5283.222"
        y1="384.738"
        y2="384.738"
        gradientTransform="matrix(0 -23.666 -23.666 0 9245.885 -125012.54)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#vGradFord)"
        d="M142.457 48.813c-1.089 2.083-2.885 3.193-4.608 3.732 0 0-.361.082-.307.412.042.37 1.264 1.144 2.027 1.687.111-.03.277-.091.277-.091.884-.351 2.358-1.25 3.21-3.115.546-1.203.843-2.147.606-4.212-.172-1.44-.463-2.742-.849-3.415.745 1.509.448 3.446-.356 5.002z"
      />
      <linearGradient
        id="wGradFord"
        x1="-5286.489"
        x2="-5283.214"
        y1="385.976"
        y2="385.976"
        gradientTransform="matrix(0 -23.6715 -23.6715 0 9235.084 -125041.438)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00082e" />
        <stop offset=".321" stopColor="#010a30" />
        <stop offset=".501" stopColor="#030f39" />
        <stop offset=".647" stopColor="#071846" />
        <stop offset=".773" stopColor="#0d245a" />
        <stop offset=".809" stopColor="#0f2961" />
        <stop offset=".839" stopColor="#0b386e" />
        <stop offset=".896" stopColor="#054e83" />
        <stop offset=".951" stopColor="#015b90" />
        <stop offset="1" stopColor="#006094" />
      </linearGradient>
      <path
        fill="url(#wGradFord)"
        d="M110.553 41.375c-3.14 7.382-9.14 13.237-16.448 13.479-4.087.137-7.215-1.79-8.878-4.729 1.215 2.194 3.271 4.118 5.103 5.271 1.583.986 3.536 1.535 5.77 1.46 7.615-.26 13.385-6.536 15.299-11.838.511-1.43.112-2.962-.124-3.998-.096-.396-.227-1.299-.517-1.942h-.003c.216.531.216 1.313-.202 2.297z"
      />
      <path
        fill="#4B4B4B"
        d="M150.824 6.461C70.48 6.461 6.077 30.543 6.077 60.736c0 30.015 64.935 54.281 144.748 54.281 79.818 0 144.758-24.35 144.758-54.281-.002-29.925-64.94-54.275-144.759-54.275M7.069 61.335c-.029-6.352 2.771-12.663 8.658-18.604C36.449 21.828 90.745 7.7 150.584 7.456c79.27-.33 143.866 23.306 144.004 52.688.028 6.354-2.938 12.581-8.826 18.517-20.725 20.907-74.854 35.124-134.688 35.362-79.269.331-143.871-23.302-144.005-52.688m287.628-4.79c.052.265.088.533.134.79-.038-.256-.091-.522-.134-.79"
      />
      <linearGradient
        id="xGradFord"
        x1="-5275.769"
        x2="-5272.503"
        y1="394.509"
        y2="394.509"
        gradientTransform="scale(-39.5764 39.5764) rotate(-75 -2894.135 -3236.761)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a5a5a6" />
        <stop offset=".35" stopColor="#d7d7d7" />
        <stop offset=".65" stopColor="#d7d7d7" />
        <stop offset="1" stopColor="#a5a5a6" />
      </linearGradient>
      <path
        fill="url(#xGradFord)"
        d="M6.514 60.736c0 1.418.167 2.826.457 4.213a20.443 20.443 0 0 1-.351-3.61c-.028-6.437 2.85-12.935 8.786-18.924C36.244 21.396 90.595 7.253 150.583 7.001c8.312-.037 16.457.195 24.395.67a385.821 385.821 0 0 0-24.152-.758C70.803 6.913 6.514 30.909 6.514 60.736z"
      />
      <linearGradient
        id="yGradFord"
        x1="-4251.91"
        x2="-4285.291"
        y1="546.245"
        y2="421.667"
        gradientTransform="translate(4458.79 -474.28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a5a5a6" />
        <stop offset=".35" stopColor="#d7d7d7" />
        <stop offset=".65" stopColor="#d7d7d7" />
        <stop offset="1" stopColor="#a5a5a6" />
      </linearGradient>
      <path
        fill="url(#yGradFord)"
        d="M286.084 78.995c-20.767 20.939-75.103 35.23-135.009 35.479a384.776 384.776 0 0 1-24.854-.676c7.994.51 16.221.768 24.604.768 79.568 0 144.304-24.293 144.304-53.812 0-1.128-.104-2.245-.285-3.357.131.913.188 1.834.197 2.759.035 6.438-3.021 12.85-8.957 18.839"
      />
      <path
        fill="#FFF"
        d="M150.818 13.184c-75.439 0-136.594 21.279-136.594 47.541 0 26.258 61.155 47.541 136.594 47.541 75.433 0 136.58-21.283 136.58-47.541 0-26.262-61.148-47.541-136.58-47.541zm0 90.964c-72.788 0-131.789-19.436-131.789-43.424 0-23.987 59-43.421 131.789-43.421 72.793 0 131.787 19.435 131.787 43.421 0 23.989-58.994 43.424-131.787 43.424z"
      />
      <path
        fill="#FFF"
        d="M235.865 45.17c.189-.331-.006-.573-.424-.573-2.188 0-5.047.007-7.317.007-.543 0-.818.06-1.074.566-.84 1.609-11.064 16.928-12.967 19.901-.322.453-.716.395-.761-.123-.188-1.768-1.717-3.805-4.121-4.771-1.834-.745-3.625-.879-5.483-.63-3.363.451-6.357 2.229-8.992 4.226-3.971 3.02-7.396 6.929-11.814 9.818-2.412 1.571-5.719 2.944-7.928.896-2.004-1.854-1.773-5.977 1.283-9.166.32-.329.711-.057.65.246-.291 1.447.062 2.879 1.157 3.881 1.339 1.193 3.248 1.335 4.884.533 1.932-.955 3.065-2.805 3.397-4.896.512-3.258-1.994-6.126-5.129-6.355-2.543-.18-4.984.706-7.361 2.669-1.188.99-1.87 1.715-2.899 3.188-.254.361-.64.398-.625-.134.117-4.163-1.604-6.508-5.049-6.582-2.672-.069-5.525 1.387-7.752 3.157-2.438 1.955-4.57 4.556-6.861 6.994-.282.299-.531.285-.607-.297-.07-2.762-.766-5.435-2.042-7.333-.457-.659-1.403-.986-2.202-.54-.369.2-1.651.792-2.591 1.546-.459.383-.638.934-.438 1.642 1.23 4.128.961 8.811-.711 12.774-1.532 3.619-4.516 6.896-8.026 7.998-2.307.731-4.714.373-6.201-1.676-2.036-2.83-1.219-7.742 1.829-11.826 2.687-3.599 6.571-5.883 10.445-7.354.457-.179.552-.47.421-.857-.21-.636-.545-1.502-.683-1.896-.354-.943-1.353-1.102-2.569-.968-2.815.328-5.354 1.291-7.863 2.635-6.568 3.518-9.861 10.325-11.307 13.97-.693 1.753-1.289 2.841-2.061 3.812-1.037 1.302-2.333 2.486-4.713 4.574-.214.193-.37.59-.191.963.242.502 1.478 2.246 1.825 2.404.386.192.836-.074 1.019-.205 1.663-1.125 3.654-2.912 4.627-4.129.341-.414.692-.238.875.389.906 3.25 3.287 5.896 6.577 7.002 6.027 2.027 12.275-.91 16.99-6.026 2.997-3.256 4.079-5.351 5.228-6.771 1.947-2.414 5.79-7.812 10.362-11.274 1.68-1.278 3.667-2.252 4.662-1.604.801.52 1.061 1.721-.228 4.062-4.662 8.52-11.526 18.528-12.789 20.948-.227.422-.024.756.416.756 2.438-.012 4.861-.006 7.074-.006.371-.017.533-.188.719-.448 3.582-5.604 6.951-10.935 10.562-16.448.201-.321.387-.071.396.066.072 1.285.39 3.031 1.147 4.181 1.361 2.124 3.296 3.037 5.443 3.053 1.707.02 2.566-.24 4.41-.929a15.391 15.391 0 0 0 3.621-1.946c.537-.373.633.256.619.354-.826 4.447.191 9.72 4.614 11.9 5.296 2.61 11.105-1.056 14.446-4.365.329-.319.678-.289.713.398.067 1.271.643 2.768 1.688 3.812 2.799 2.813 8.457 1.699 14.127-2.691 3.646-2.813 7.459-6.787 10.908-10.993.121-.164.221-.429-.025-.689-.521-.549-1.281-1.176-1.803-1.662-.238-.198-.584-.141-.789.011-3.529 3.354-6.703 7.188-11.299 10.35-1.549 1.086-4.016 1.957-5.127.457-.432-.582-.382-1.393.043-2.447 1.344-3.347 22.548-35.627 23.645-37.529m-28.021 27.068c.045.248.365.486.684.602.107.044.172.118.043.38-.897 1.934-1.727 3.045-2.857 4.727-1.036 1.55-2.211 2.763-3.625 3.926-2.139 1.769-5.108 3.691-7.563 2.396-1.09-.562-1.562-2.088-1.537-3.326.056-3.475 1.593-7.039 4.445-10.543 3.479-4.285 7.328-6.506 9.852-5.295 2.609 1.246 1.777 4.271.609 6.647-.09.18-.1.338-.051.486"
      />
      <path
        fill="#FFF"
        d="M82.087 90.613c-7.905.057-14.865-4.834-15.666-13.286-.443-4.685.881-8.865 3.533-12.306 2.352-3.066 6.338-5.612 9.702-6.236 1.103-.199 2.575-.069 3.187.655.954 1.113.676 2.337-.274 2.822-2.572 1.312-5.668 3.561-7.196 6.629-1.242 2.5-1.494 5.525.398 8.399 3.179 4.79 12.025 4.925 20.252-2.721 2.039-1.873 3.861-3.67 5.719-5.795 3.622-4.147 4.825-5.66 9.643-12.339.061-.075.077-.175.051-.225-.039-.087-.109-.112-.25-.118-3.213.089-6.019 1.05-8.741 3.083-.785.571-1.915.49-2.409-.262-.549-.852-.156-1.961.75-2.585 4.381-3.046 9.171-3.602 14.062-4.429-.003 0 .342.014.619-.356 2.007-2.574 3.522-4.898 5.665-7.506 2.157-2.642 4.94-5.064 7.069-6.893 2.971-2.556 4.876-3.415 6.812-4.468.511-.268-.062-.587-.221-.587-10.809-2.029-22.042-4.661-32.774-.687-7.437 2.776-10.697 8.673-9.124 12.61 1.11 2.794 4.787 3.247 8.227 1.565a18.62 18.62 0 0 0 7.378-6.561c1.047-1.613 3.255-.45 2.062 2.354-3.14 7.382-9.14 13.237-16.448 13.479-6.223.206-10.238-4.369-10.222-10.016.021-11.138 12.424-18.474 25.451-19.572 15.691-1.294 30.553 2.886 46.129 4.775 11.938 1.443 23.384 1.473 35.38-1.281 1.416-.308 2.416.595 2.318 2.028-.117 2.071-1.722 4.064-5.67 6.22-4.496 2.467-9.193 3.212-14.104 3.255-11.875.097-22.938-4.53-34.382-7.016.016.499.146 1.098-.274 1.414-6.338 4.674-12.069 9.425-15.909 16.092-.127.156-.057.3.166.284 3.332-.175 6.332-.259 9.44-.508.542-.045.562-.179.517-.577-.273-2.299.396-4.922 2.418-6.727 2.068-1.853 4.66-2.063 6.376-.731 1.953 1.523 1.781 4.262.715 6.316-1.089 2.083-2.885 3.193-4.608 3.732 0 0-.361.082-.307.412.067.522 2.416 1.826 2.617 2.173.194.327.097.839-.265 1.23-.249.284-.638.553-1.133.546-.409-.009-.651-.149-1.165-.431-1.06-.568-2.371-1.506-3.252-2.615-.297-.372-.45-.382-1.2-.34-3.364.196-8.613.7-12.172 1.147-.858.107-.986.268-1.165.562-5.671 9.354-11.725 19.437-18.373 26.188-7.132 7.252-13.062 9.152-19.352 9.204m54.035-41.548c.093.478.277.571.495.53 1.079-.216 2.259-1.106 2.961-2.132.64-.935.937-2.284.303-2.826-.565-.483-1.484-.343-2.167.258-1.353 1.199-1.764 2.898-1.592 4.17"
      />
    </svg>
  );
}
export default FordIcon;
